import React, { memo } from 'react';
import { ScrollView } from 'react-native';

export const FilterChipRow = memo(({ children, paddingHorizontal = 11 }) => (
  <ScrollView
    horizontal
    showsHorizontalScrollIndicator={false}
    nestedScrollEnabled
    keyboardShouldPersistTaps="handled"
    contentContainerStyle={{
      alignItems: 'center',
      paddingHorizontal,
    }}
    style={{ flexGrow: 0 }}
  >
    {children}
  </ScrollView>
));

FilterChipRow.displayName = 'FilterChipRow';

export default FilterChipRow;
